import BaseStore from './BaseStore';
import { ActionTypes, MAX_NOTIFICATION_TIME } from '../constants/AppConstants';


class NotificationStore extends BaseStore {

    getActive () {
        return this.state.get('active');
    }

    hide ({ notification }) {
        if (!notification || notification === this.getActive() || Date.now() - this.get('timestamp') > MAX_NOTIFICATION_TIME) {
            this.setState(this.state.delete('active'));
        }
    }

    open ({ notification }) {
        this.setState(this.state.merge({
            active: notification,
            timestamp: Date.now()
        }));
    }

    getActionHandlers () {
        return {
            [ActionTypes.NOTIFICATION_SHOW]: this.open,
            [ActionTypes.NOTIFICATION_HIDE]: this.hide
        };
    }

}

const storeInstance = new NotificationStore();

export default storeInstance;
